import { useCSSPropertys, useCSSPropertyState } from '@/hooks/useCSSPropertys';
import { createContext } from 'react';

export const CSSPropertyContext = createContext({} as useCSSPropertyState);

type Props = {
    children: JSX.Element;
};
export const CSSPropertyProvider = ({ children }: Props) => {
    const value = useCSSPropertys();
    return (
        <CSSPropertyContext.Provider value={value}>
            {children}
        </CSSPropertyContext.Provider>
    );
};
